export default __webpack_public_path__ + "static/media/car.55e6a4b0.svg";